import module from '../gift-deets.module';

module.factory('GiftCommentsService', [
  '$resource',
  function ($resource) {
    var resource = $resource('/api/gift-comments/:giftId', { giftId: '@id' });

    return {
      getComments: function (giftId) {
        return resource.query({ giftId }).$promise;
      },

      addComment: function (comment) {
        var rs = $resource('/api/gift-comments');
        return rs.save(comment).$promise;
      },
    };
  },
]);
